// Module
var code = "<td name=shipmentUnitWrapperCategory>{{ record.key | entityFormat }}</td> <td name=quantity>{{ getRemainingQuantity(record) }}</td> ";
// Exports
module.exports = code;